import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import ButtonList from './ButtonList';
import './CardItem.scss';

const GrbCardItem = (props) => {
  const {
    icon: Icon,
    number,
    className,
    id,
    title,
    value,
    error,
    buttons,
    renderButtons,
    link,
    tooltip,
    object,
    gutterSize,
    children,
    ...rest
  } = props;
  let header;
  if (Icon) {
    header = <Icon />;
  } else if (number !== undefined) {
    header = <Typography variant="h6">{number}</Typography>;
  }
  let content;
  if (!!title || (value !== undefined)) {
    let valueCmp;
    if (value !== undefined) {
      valueCmp = link ? (
        <a
          className="grb-card-item-value-link"
          href={link}
          aria-label="link"
        >
          <Typography variant="body2" className="grb-card-item-value">{value}</Typography>
        </a>
      ) : (
        <Typography variant="body2" className="grb-card-item-value">{value}</Typography>
      );
      if (tooltip) {
        valueCmp = <Tooltip title={tooltip}>{valueCmp}</Tooltip>;
      }
    }
    if (renderButtons || (buttons && buttons.length)) {
      content = (
        <div className="grb-card-item-box">
          <div className="grb-card-item-box-body">
            {title && <Typography variant="body2" className="grb-card-item-title">{title}</Typography>}
            {valueCmp}
          </div>
          <ButtonList {...rest} buttons={buttons} renderButtons={renderButtons} object={object} />
        </div>
      );
    } else {
      content = (
        <React.Fragment>
          {title && <Typography variant="body2" className="grb-card-item-title">{title}</Typography>}
          {valueCmp}
        </React.Fragment>
      );
    }
  }

  return (
    <li className={classnames('grb-card-item', className, error && 'grb-error', gutterSize && `grb-card-item-gutter-${gutterSize}`)} id={id}>
      <div className="grb-card-item-icon">
        {header}
      </div>
      <div className="grb-card-item-content">
        <div className="grb-flex-vert">
          {content}
          {children}
        </div>
      </div>
    </li>
  );
};

GrbCardItem.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  icon: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({}),
  ]),
  number: PropTypes.number,
  title: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  link: PropTypes.string,
  tooltip: PropTypes.string,
  buttons: PropTypes.arrayOf(PropTypes.shape()),
  renderButtons: PropTypes.func,
  error: PropTypes.bool,
  object: PropTypes.shape({}),
  children: PropTypes.node,
  gutterSize: PropTypes.string,
};

GrbCardItem.defaultProps = {
  className: undefined,
  id: undefined,
  number: undefined,
  title: undefined,
  icon: undefined,
  error: false,
  link: undefined,
  tooltip: undefined,
  value: undefined,
  buttons: undefined,
  renderButtons: undefined,
  object: undefined,
  children: undefined,
  gutterSize: 'normal',
};

export default GrbCardItem;
